import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppInjector } from 'src/app-injector';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-warning-snackbar',
  templateUrl: './warning-snackbar.component.html',
  styleUrls: ['./warning-snackbar.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarningSnackbarComponent {
  dialog: MatDialog;
  settingsIntegratiesLink: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBarRef: MatSnackBarRef<WarningSnackbarComponent>, public globals: Globals, private router: Router) {
    this.dialog = AppInjector ? AppInjector.get(MatDialog) : null;
    const currentUrl = this.router.url;
    let finalUrl = '';
    if (currentUrl.includes('/sub/')) {
      const splitUrl = currentUrl.split('/');
      const subIndex = splitUrl.indexOf('sub');
      const baseUrl = splitUrl.slice(1, subIndex + 2).join('/');
      finalUrl = `/${baseUrl}/instellingen/integraties`;
    } else {
      finalUrl = `/${this.globals.projectCode}/instellingen/integraties`;
    }
    this.settingsIntegratiesLink = finalUrl;
  }
}
